import { EventsCacheLockId } from 'owa-calendar-events-store';
import { getStore } from '../store/store';

export function getUpNextEventLockId(): EventsCacheLockId {
    return getStore().upNextEventLockId;
}
